import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-modal" }
const _hoisted_2 = { class: "wrapper-modal" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_GeneralTextArea = _resolveComponent("GeneralTextArea")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "title" }, "Anulación No. provisional 1232143", -1)),
        _createVNode(_component_CloseButton, { onClick: _ctx.closeModal }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_GeneralTextArea, {
          text: _ctx.reason.val,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason.val) = $event)),
          value: _ctx.reason.val,
          label: 'Motivo de anulación',
          "has-error": _ctx.reason.enabled,
          error: _ctx.reason.errors.length === 0 ? '' : _ctx.reason.errors[0]
        }, null, 8, ["text", "value", "has-error", "error"])
      ]),
      _createVNode(_component_StandardButton, {
        buttonLabel: 'Anular',
        class: "margin-button",
        "is-disabled": _ctx.successForm,
        onClick: _ctx.nullify
      }, null, 8, ["is-disabled", "onClick"])
    ])
  ]))
}